<template>
    <div class='card'
        v-bind:style="{
            'background': 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(' + image + ') center',
            'background-size': 'cover'
        }">
        <h2 class="title has-text-white">{{ title }}</h2>
        <div class="content">
            <p v-html="text" />
            <br />
            <b>{{ conclusion }}</b>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Card',
    props: {
        title: String,
        text: String,
        conclusion: String,
        image: String
    }
}
</script>

<style scoped>
.card {
	margin: 0 auto;
	padding: 5%;
	width: 100%;
    border-radius: 5px;
	color: whitesmoke;
	background-size: cover;
	box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}

.card .content {
    width: 75%;
    line-break: break-all;
}
</style>